import { render, staticRenderFns } from "./CancelEndorsement.vue?vue&type=template&id=0edcf0e1"
import script from "./CancelEndorsement.vue?vue&type=script&lang=js"
export * from "./CancelEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports